import { motion } from "framer-motion";
import { Eye, Compass, Target } from "lucide-react";
import { fadeUp } from "./shared";

const CARDS = [
  { icon: Eye, tone: "turq", testid: "vision-card-vision", title: "رؤيتنا",
    text: "أن تكون المنطقة الشرقية نموذجاً وطنياً رائداً في التطوع المدرسي، يخرج من مدارسها جيلٌ يعطي بلا حدود ويعتز ببصمته في مجتمعه." },
  { icon: Compass, tone: "coral", testid: "vision-card-mission", title: "رسالتنا",
    text: "تمكين كل مدرسة ومنسّق من رصد العطاء التطوعي بسهولة وعدالة، وقياس أثره بالطلاب الفريدين لا بالأرقام المضخّمة — عبر مؤشر تمكين شفاف ومنافسة محفّزة بالشرائح." },
  { icon: Target, tone: "beige", testid: "vision-card-goal", title: "مستهدفنا",
    text: "بلوغ مؤشر التمكين 90% في كل مدرسة من مدارس المنطقة، إسهاماً في مستهدف رؤية المملكة 2030 بالوصول إلى مليون متطوع — وتكريم كل من يصنع الفرق بشهادات وأوسمة تليق بعطائه." },
];

const TONE_CLS = {
  turq: "bg-turq-100 dark:bg-surface2 text-turq-600",
  coral: "bg-coral-100 dark:bg-surface2 text-coral-600",
  beige: "bg-beige-100 dark:bg-surface2 text-beige-600",
};

export function VisionSection() {
  return (
    <section id="vision" className="max-w-6xl mx-auto px-5 py-14">
      <div data-testid="vision-section" className="text-center max-w-3xl mx-auto mb-10">
        <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp}>
          <span className="inline-block bg-turq-100 dark:bg-surface2 text-turq-900 dark:text-turq-300 text-[11px] font-bold px-4 py-1.5 rounded-full mb-4">
            easternschoolsvolunteering.com
          </span>
          <h2 data-testid="vision-welcome-title" className="font-head font-black text-3xl sm:text-4xl leading-snug mb-4">
            أهلاً بكم في <span className="text-turq-600">عطاء</span>… حيث تتطوّع <span className="text-coral-600">الشرقية</span>
          </h2>
          <p className="text-mutext text-sm sm:text-base leading-loose">
            من الدمام إلى الخبر، ومن الجبيل إلى حفر الباطن — هذه المنصة هي البيت الرقمي لكل ساعة عطاء في مدارس المنطقة الشرقية.
            نوثّق الجهد، نُنصف المدارس الصغرى والكبرى، ونحوّل التطوع المدرسي إلى أثرٍ مرئي يُقاس ويُحتفى به.
          </p>
        </motion.div>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {CARDS.map((c, i) => (
          <motion.div key={c.testid} initial="hidden" whileInView="show" viewport={{ once: true }}
            variants={{ ...fadeUp, show: { ...fadeUp.show, transition: { delay: i * 0.1, duration: 0.55 } } }}
            data-testid={c.testid}
            className="bg-surface rounded-3xl border border-brd p-6 shadow-md shadow-turq-900/5 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-4 ${TONE_CLS[c.tone]}`}>
              <c.icon className="w-6 h-6" />
            </div>
            <h3 className="font-head font-black text-xl mb-2.5">{c.title}</h3>
            <p className="text-[12.5px] text-mutext leading-loose">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
